import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight } from 'react-icons/fi';

export default function DogsForAdoption() {
  const [dogs, setDogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDogs = async () => {
      setLoading(true);
      try {
        const res = await fetch('/api/dogs');
        if (!res.ok) throw new Error('API unavailable');
        const data = await res.json();
        setDogs(Array.isArray(data) ? data : []);
      } catch {
        try {
          const fallback = await fetch('/data/dogs.json');
          const data = await fallback.json();
          setDogs(Array.isArray(data) ? data : []);
        } catch (e) {
          console.error('Error loading dogs:', e);
        }
      } finally {
        setLoading(false);
      }
    };
    fetchDogs();
  }, []);

  return (
    <div className="fade-in inner-page">
      {/* Header */}
      <section className="page-hero">
        <div className="site-container page-hero__content">
          <span className="eyebrow eyebrow--light">Nowy przyjaciel jest bliżej, niż myślisz</span>
          <h1>Psy do adopcji</h1>
          <p>Poznaj naszych podopiecznych i znajdź towarzysza, z którym napiszesz nowy rozdział.</p>
        </div>
      </section>

      {/* Content */}
      <div className="site-container page-content">
        {/* Dogs Grid */}
        {loading ? (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">Ładowanie psów...</p>
          </div>
        ) : dogs.length === 0 ? (
          <div className="text-center py-12">
            <p className="text-gray-600 text-lg">Nie znaleziono psów.</p>
          </div>
        ) : (
          <div className="dog-grid dog-grid--listing">
            {dogs.map((dog, index) => (
              <Link key={dog.id} to={`/dogs/${dog.id}`} className="dog-card">
                <div className="dog-card__media">
                  {dog.photo ? (
                    <img src={dog.photo} alt={dog.name} loading={index > 5 ? 'lazy' : 'eager'} />
                  ) : (
                    <div className="dog-card__placeholder">
                      <span className="text-6xl">🐕</span>
                    </div>
                  )}
                  <span className={`status-pill status-pill--${dog.status || 'available'}`}>
                    {dog.status === 'available' ? 'Do adopcji' : dog.status === 'pending' ? 'W trakcie' : 'Adoptowany'}
                  </span>
                </div>
                  <div className="dog-card__body">
                    <div className="dog-card__title-row">
                      <h3>{dog.name}</h3>
                      <span className="dog-card__arrow"><FiArrowRight aria-hidden="true" /></span>
                    </div>
                    <p>{dog.description}</p>
                    <div className="dog-card__meta-row">
                      {dog.age && <span className="dog-card__meta">{dog.age} {dog.age === 1 ? 'rok' : 'lat'}</span>}
                      {dog.gender && <span className="dog-card__meta">{dog.gender === 'Male' ? 'Samiec' : 'Samica'}</span>}
                    </div>
                  </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
